<script setup lang="ts">
import { useI18n } from "vue-i18n";

import type { ProfilPreviewWarningModalProps } from "@/components/modal/Profile/previewProfile/types";

import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = defineProps<ProfilPreviewWarningModalProps>();

const emit = defineEmits<{
    (e: "close"): void;
    (e: "continueWithoutSaving"): void;
    (e: "save"): void;
}>();

const { t } = useI18n();

const handleClose = () => {
    emit("close");
};

const handleContinueWithoutSaving = () => {
    emit("continueWithoutSaving");
};

const handleSave = () => {
    emit("save");
};
</script>

<template>
    <Modal :open="open" :title="t('modals.profilPreview.warningModal.title')" position="center" width="420px" close action @close="handleClose">
        <div class="profil-preview-warning-modal__content typo-sm-medium">
            {{ t("modals.profilPreview.warningModal.content") }}
        </div>

        <template #footer>
            <div class="profil-preview-warning-modal__footer">
                <ButtonAlt
                    :label="t('modals.profilPreview.warningModal.actions.continueWithoutSaving')"
                    type="neutral"
                    data-bot="continue-without-saving"
                    @click="handleContinueWithoutSaving"
                />
                <ButtonAlt :label="t('global.actions.save')" variant="filled" data-bot="save" @click="handleSave" />
            </div>
        </template>
    </Modal>
</template>

<style scoped lang="scss">
.profil-preview-warning-modal {
    &__content {
        color: var(--text-sub-600, #494e61);
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-md, 8px);
    }
}
</style>
